export const AboutData = {
  about1:
    "Extensive experience capturing powerful visuals that drive Brand Visibility, Trust, and Growth.",
  about2:
    "A seasoned broadcaster skilled in delivering compelling audio that connects with your audience.",
  about3:
    "Crafting Results-driven strategies across Instagram, TikTok, X, Meta & Google Ads.",
  about4:
    "Expert in vocal storytelling producing professional audio for Brands, Ads, and Social Media.",
  about5:
    "Proven results with 10+ businesses across various industries bossting their Reach, Sales, and Engagement.",
};

// CROSS-PLATFORM MEDIA EXPERTISE
// Proven experience delivering tailored content across Instagram, TikTok, X, Meta & Google Ads — built on a strategic digital marketing ecosystem.

// 1400+ HOURS OF FILMING
// Extensive hands-on experience capturing powerful visuals that drive brand visibility, trust, and digital growth.

// 12+ YEARS IN RADIO
// A seasoned broadcaster skilled in delivering clear, compelling audio that connects with diverse audiences.

// 8+ YEARS AS VOICE ACTOR
// Expert in vocal storytelling — producing professional, emotionally tuned audio for brands, ads, and media.

// 10+ CLIENTS SERVED
// Experience-backed results for brands across industries — from boosting reach to increasing engagement and conversions.

// export const AboutData = {
//   about1:
//     "Masterfully captured moments through years of experience — producing high-impact visuals that boost brand recognition, trust, and digital presence.",
//   about2:
//     "A seasoned voice in broadcasting, delivering compelling audio content that resonates with listeners and builds meaningful audience connection.",
//   about3:
//     "Deliver tailored content across Instagram, TikTok, X, Meta & Google Ads aligned to a strategic digital marketing plan.",
//   about4:
//     "Professional storytelling through voice — crafting emotional, clear, and brand-aligned audio that powers commercials, explainers, and podcasts.",
//   about5:
//     "Trusted by brands across industries. Our tailored approach delivers results — from increasing visibility to elevating audience interaction.",
// };
